import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CenteredText } from './CenteredText';
import { RightText } from './RightText';
import { MarkerDef } from './MarkerDef';
/**
 * Creates a simple arrow between 2 points. The arrow has one inflection point, which is the middle of the line.
 * The SVG must define a marker with id="arrowhead" for this to work.
 * @param props
 * @returns
 */
export function Arrow(props) {
    const { from, to, label, labelPosition } = props;
    const middle = { x: (from.x + to.x) / 2, y: (from.y + to.y) / 2 };
    const refX = MarkerDef(props).props.children.props.refX;
    const headInflectionPoint = {
        x: to.x - refX * 2,
        y: to.y,
    };
    const d = `M ${from.x} ${from.y} C ${middle.x} ${from.y}  ${middle.x} ${to.y}  ${headInflectionPoint.x} ${to.y} Q ${headInflectionPoint.x} ${to.y}  ${to.x} ${to.y} `;
    //const d = `M ${from.x} ${from.y} C ${middle.x} ${from.y}  ${middle.x} ${from.y}  ${middle.x} ${middle.y} ${middle.x} ${to.y} ${middle.x} ${to.y}  ${to.x} ${to.y}`;
    return (_jsxs("g", { children: [_jsx("path", { d: d, style: {
                    fill: 'none',
                    strokeWidth: '2',
                    stroke: 'black',
                    markerEnd: 'url(#arrowhead)',
                } }), labelPosition === 'center' && (_jsx(CenteredText, { x: middle.x, y: middle.y, label: label })), labelPosition === 'right' && (_jsx(RightText, { x: to.x - 12, y: to.y - 8, label: label }))] }));
}
//# sourceMappingURL=Arrow.js.map